export const BASE_RATE = 0.065;
export const APRA_BUFFER = 0.03;
export const BONUS_HAIRCUT = 0.5;
export const CC_ASSESSMENT_FACTOR = 0.038;
export const HECS_MONTHLY = 400;
export const RENTAL_YIELD = 0.035;
export const RENTAL_SHADE = 0.8;
export const PURCHASE_FEES_PCT = 0.005;
export const LOAN_TERM_MONTHS = 360;
// Standard no-LMI LVR ceiling. Drives the "required deposit" the borrower must
// bring for the funds-to-complete / deposit-gap check (1 - 0.80 = 20% deposit).
export const NO_LMI_LVR = 0.8;

export const STATE_OPTIONS = [
  { value: 'NSW', label: 'NSW' },
  { value: 'VIC', label: 'VIC' },
  { value: 'QLD', label: 'QLD' },
  { value: 'WA', label: 'WA' },
  { value: 'SA', label: 'SA' },
  { value: 'ACT', label: 'ACT' },
];

export const SITUATION_OPTIONS = [
  { value: 'single_0', label: 'Single' },
  { value: 'couple_0', label: 'Couple' },
  { value: 'single_1', label: 'Single + kids' },
  { value: 'couple_1', label: 'Couple + kids' },
];

export const CITIZENSHIP_OPTIONS = [
  { value: 'australian_citizen', label: 'AU Citizen' },
  { value: 'australian_pr_visa', label: 'AU PR' },
  { value: 'foreign_national', label: 'Foreign National' },
];

// Cashflow projection constants
export const INDIC_RATE = 0.065;
export const MGMT_PCT = 0.08;
export const RATES_INS_PCT = 0.004;
export const MAINT_PCT = 0.003;
export const STRATA_PCT = 0.004;

import type { IncomeTaxBracket } from '../types';

export const INCOME_TAX_BRACKETS: IncomeTaxBracket[] = [
  {
    taxResidency: 'non_resident',
    lowerIncomeThreshold: '0.00',
    upperIncomeThreshold: '135000.00',
    baseTaxAud: '0.00',
    taxRateOnExcess: '30.00',
  },
  {
    taxResidency: 'non_resident',
    lowerIncomeThreshold: '135001.00',
    upperIncomeThreshold: '190000.00',
    baseTaxAud: '40500.00',
    taxRateOnExcess: '37.00',
  },
  {
    taxResidency: 'non_resident',
    lowerIncomeThreshold: '190001.00',
    upperIncomeThreshold: '9999999.00',
    baseTaxAud: '60850.00',
    taxRateOnExcess: '45.00',
  },
  {
    taxResidency: 'resident',
    lowerIncomeThreshold: '0.00',
    upperIncomeThreshold: '18200.00',
    baseTaxAud: '0.00',
    taxRateOnExcess: '0.00',
  },
  {
    taxResidency: 'resident',
    lowerIncomeThreshold: '18201.00',
    upperIncomeThreshold: '45000.00',
    baseTaxAud: '0.00',
    taxRateOnExcess: '16.00',
  },
  {
    taxResidency: 'resident',
    lowerIncomeThreshold: '45001.00',
    upperIncomeThreshold: '135000.00',
    baseTaxAud: '4288.00',
    taxRateOnExcess: '30.00',
  },
  {
    taxResidency: 'resident',
    lowerIncomeThreshold: '135001.00',
    upperIncomeThreshold: '190000.00',
    baseTaxAud: '31288.00',
    taxRateOnExcess: '37.00',
  },
  {
    taxResidency: 'resident',
    lowerIncomeThreshold: '190001.00',
    upperIncomeThreshold: '9999999.00',
    baseTaxAud: '51638.00',
    taxRateOnExcess: '45.00',
  },
];

export const PROPERTY_USE_OPTIONS = [
  { value: 'investment', label: 'Investment' },
  { value: 'owner_occupied', label: 'Live in (OO)' },
];
